import type React from "react";

import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const MainMenu: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <li>
        <Link to="/">{t("header.mainmenu.home")}</Link>
      </li>
      <li>
        <Link to="/books" search={{ owned: true }}>
          {t("header.mainmenu.mybooks")}
        </Link>
      </li>
      <li>
        <Link to="/books" search={{ read: "reading" }}>
          {t("header.mainmenu.currentlyreading")}
        </Link>
      </li>
      <li>
        <Link to="/books" search={{ owned: true, tbr: true }}>
          {t("header.mainmenu.readinglist")}
        </Link>
      </li>
      <li>
        <Link to="/books" search={{ owned: false, tbr: true }}>
          {t("header.mainmenu.wanted")}
        </Link>
      </li>
    </>
  );
};
